import React, { useEffect } from "react";
import {
  Box,
  Button,
  InputAdornment,
  MenuItem,
  Pagination,
  Stack,
} from "@mui/material";
import {
  ControlPoint as ControlPointIcon,
  VerticalAlignBottom as VerticalAlignBottomIcon,
  FilterList as FilterListIcon,
} from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import TableToExcel from "@linways/table-to-excel";

import useReducer from "../../../../library/hooks/useReducer";
import CommonTable from "../../../../library/layout/commonTable";
import { columns } from "../components/columnsProductManager";
import { TextField } from "../overrideMui/index";
import { productManagerV2 } from "../styles/styleProductManagerV2";
import { initialStateProductManager } from "../util";
import PopoverFilter from "../components/popoverFilter";
import productManagerReducer from "../reducers/productManagerReducer";
import LoadingMui from "../../../../ui/LoadingMui";
import Snackbars from "../../../../ui/snackbar";

import searchIcon from "./../../../../assets/icons/search-icon.svg";
import TableExportExcelProduct from "../components/TableExportExcel";
import { debounce } from "lodash";
// import { DatePicker } from "@mui/x-date-pickers";
import { DatePicker } from "antd";
import moment from "moment";

export default function ManagerProduct() {
  const classes = productManagerV2();
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const dataSelect = [{ label: "BH con người", id: 1 }];

  const [state, dispatch, clearStateGlobal] = useReducer({
    initialState: initialStateProductManager,
    reducer: productManagerReducer,
    name: "productManagerReducer",
  });

  const {
    listProducts,
    loading,
    snackbar,
    pageTable,
    dataSearch,
    dataExportExcel,
    count,
  } = state;
  let flag = false;

  useEffect(() => {
    dispatch("initial");

    return clearStateGlobal();
  }, []);

  useEffect(async () => {
    if (count !== 0) {
      const table = document.getElementById("export-data-table");
      TableToExcel.convert(table, {
        name: `bao-cao-san-pham.xlsx`,
        sheet: {
          name: "Sheet 1",
        },
      });
    }
  }, [count]);

  const newColumns =
    user?.extra_info?.userType === "globalcare"
      ? columns
      : columns.filter((i) => !i.isGC);

  return (
    <div className={classes.container}>
      <Box className={classes.box_heder}>
        <div className="title-decentraliza">Sản phẩm</div>
        {user?.role_management_claim?.privileges?.PRODUCT_MANAGE === 1 && (
          <div>
            <Button
              className="buttons-add-decentraliza"
              onClick={() =>
                history.push(`/admin/product-management/create/new`)
              }
            >
              <ControlPointIcon fontSize="small" className="icon-button" />
              Tạo sản phẩm
            </Button>
          </div>
        )}
      </Box>
      <Box className={classes.box_button}>
        <div className="search-box">
          <TextField select className="text-field-selecter" defaultValue={1}>
            {dataSelect.map((select, index) => (
              <MenuItem key={select.name} value={select.id}>
                {select.label}
              </MenuItem>
            ))}
          </TextField>
          <span>Chọn ngày</span>
          <DatePicker
            value={dataSearch?.from ? moment(dataSearch?.from) : null}
            onChange={(e) =>
              dispatch({
                type: "applyFilter",
                name: "from",
                value: e?.format("YYYY-MM-DD") || null,
              })
            }
            allowClear={true}
            style={{
              ...Styles.input,
            }}
            placeholder="Từ ngày"
            format="DD/MM/YYYY"
          />

          <span>{" - "}</span>
          <DatePicker
            value={dataSearch?.to ? moment(dataSearch?.to) : null}
            onChange={(e) =>
              dispatch({
                type: "applyFilter",
                name: "to",
                value: e?.format("YYYY-MM-DD") || null,
              })
            }
            allowClear={true}
            style={{
              ...Styles.input,
            }}
            placeholder="Đến ngày"
            format="DD/MM/YYYY"
          />

          <TextField
            placeholder="Nhập tên..."
            className="text-field-search"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <img src={searchIcon} alt="search_icon" />
                </InputAdornment>
              ),
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                dispatch({
                  type: "applyFilter",
                  keyword: e.target.value,
                });
                flag = true;
              }
            }}
            onChange={debounce((e) => {
              if (!flag) {
                dispatch({
                  type: "applyFilter",
                  keyword: e.target.value,
                });
              }
              flag = false;
            }, 1800)}
          />
        </div>
        <div className="div-buttons">
          {user?.role_management_claim?.privileges?.PRODUCT_EXPORT === 1 && (
            <Button
              className="button dowload"
              onClick={() => dispatch("exportFileExcel")}
            >
              <VerticalAlignBottomIcon
                fontSize="small"
                sx={{ marginRight: "8px" }}
              />
              Xuất file
            </Button>
          )}
          <Button className="button" onClick={() => dispatch("openFilter")}>
            <FilterListIcon fontSize="small" sx={{ marginRight: "8px" }} />
            Bộ lọc
          </Button>
        </div>
      </Box>
      <div>
        <CommonTable
          columns={newColumns}
          rows={listProducts}
          classes={classes}
          data={{ history }}
          event={(type, data) =>
            (ele, ...rest) => {
              dispatch({ type, data, ele, rest });
            }}
        />

        <div className={classes.footer}>
          <div className="rows-per-page">{`Hiển thị ${
            (pageTable.page - 1 || 0) * 20 + 1
          }-${
            (pageTable.page - 1 || 0) * 20 + 20 > pageTable.total
              ? pageTable.total
              : (pageTable.page - 1 || 0) * 20 + 20
          } trong ${pageTable.total || 0}`}</div>
          <Stack spacing={2}>
            <Pagination
              count={pageTable.count || 0} // số trang
              page={pageTable.page || 1} // đang đứng trang thứ
              onChange={(e, pageNumber) =>
                dispatch({ type: "onChangePage", e, pageNumber })
              }
              variant="outlined"
              color="primary"
            />
          </Stack>
        </div>
      </div>
      <TableExportExcelProduct data={listProducts} dataSearch={dataSearch} />
      <PopoverFilter {...{ state, dispatch, user }} />
      <LoadingMui loading={Boolean(loading)} />
      <Snackbars
        open={Boolean(snackbar.open)}
        type={snackbar.type}
        message={snackbar.message}
        onClose={() => dispatch("onCloseSnackbar")}
      />
    </div>
  );
}

const Styles = {
  input: {
    fontSize: 16,
    boxShadow: "none",
    borderRadius: 16,
    width: "100%",
    border: "1px solid #A0A0A0",
    maxWidth: "130px",
    margin: "0 6px",
    padding: "6px 11px",
  },
};
